let api = api = "http://backend.siscotech.com/";
let paypalExtra = {
  sandbox_id: 'ASEwa_33gGcRc9tSgMfm3jXtcix3FqqxUlnvJVPW6b30cizDs5aaTdPhlMDi9a433GVTp0C5wyoiWElq',
  production_id: 'ASumQY-eiE9UP0vqlErbJ8Ey1g8VKT0NWRsQbWSiGhTpmgXbChsSaunZHzx4tf0CDGBO2I9COEH_OgTy',
  mode: 'production',
};

export default {
  api,
  paypalExtra,
}